<template>
  <div class="stamo-navbar">
    <b-navbar style="height: 27px">
      <template #brand>
        <b-navbar-item @click="toggleMenu" class="gold-nav-item">
          <b-icon type="is-white" :icon="togglerArrow"></b-icon>
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/' }" class="logo">
          <img style="height: 9px" :src="logo" alt="Goldmedia" />
        </b-navbar-item>
      </template>

      <template #start v-if="isAdminRoute && isPermited('admin')">
        <b-navbar-item
          tag="router-link"
          class="gold-nav-item is-hidden-desktop pl-4"
          :to="{ name: 'Home' }"
        >
          <b-icon icon="home"></b-icon>
        </b-navbar-item>
        <b-dropdown>
          <template #trigger>
            <a class="navbar-item gold-nav-item">
              <b-icon icon="users"></b-icon>
              <span class="is-hidden-touch ml-2">
                <span>Kunden</span>
              </span>
              <b-icon icon="angle-down" class="ml-1"></b-icon>
            </a>
          </template>
          <b-dropdown-item has-link>
            <router-link :to="{ name: 'AllUsers' }"> Nutzer </router-link>
          </b-dropdown-item>
          <b-dropdown-item has-link>
            <router-link :to="{ name: 'AllOrgs' }">
              Organisationen
            </router-link>
          </b-dropdown-item>
        </b-dropdown>
        <div
          class="is-hidden-touch ml-1 mr-2"
          style="align-self: center; color: white"
        >
          |
        </div>
        <b-dropdown>
          <template #trigger>
            <a class="navbar-item gold-nav-item">
              <b-icon icon="puzzle-piece"></b-icon>
              <span class="is-hidden-touch ml-2">
                <span>Produkte</span>
              </span>
              <b-icon icon="angle-down" class="ml-1"></b-icon>
            </a>
          </template>
          <b-dropdown-item has-link>
            <router-link :to="{ name: 'AllProducts' }"> Produkte </router-link>
          </b-dropdown-item>
          <b-dropdown-item has-link>
            <router-link :to="{ name: 'ManageProduct' }">
              Produkverwaltung
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item has-link>
            <router-link :to="{ name: 'AllTags' }"> Tags </router-link>
          </b-dropdown-item>
        </b-dropdown>
        <div
          class="is-hidden-touch ml-1 mr-2"
          style="align-self: center; color: white"
        >
          |
        </div>
        <b-navbar-item
          tag="router-link"
          class="gold-nav-item"
          :to="{ name: 'AllNews' }"
        >
          <b-icon icon="bullhorn"></b-icon>
          <span class="is-hidden-touch ml-2">
            <span>Nachrichten</span>
          </span>
        </b-navbar-item>
      </template>

      <template #end v-if="loggedIn">
        <b-navbar-item @click="onNavSearchClick" class="gold-nav-item">
          <b-icon icon="search"></b-icon>
        </b-navbar-item>
        <b-navbar-item
          tag="router-link"
          class="gold-nav-item"
          :class="{ 'is-hidden-touch': isAdminRoute }"
          :to="{ name: 'Home' }"
        >
          <b-icon icon="home"></b-icon>
        </b-navbar-item>
        <b-navbar-item
          v-if="isPermited('admin')"
          tag="router-link"
          class="gold-nav-item"
          :to="{ name: 'AllOrgs' }"
        >
          <b-icon icon="wrench"></b-icon>
        </b-navbar-item>
        <b-dropdown
          position="is-bottom-left"
          append-to-body
          aria-role="menu"
          class="user-dropdown"
        >
          <template #trigger>
            <a class="navbar-item gold-nav-item" role="button">
              <b-icon icon="user" pack="fas"></b-icon>
            </a>
          </template>

          <b-dropdown-item
            v-if="!loadingUser && me"
            custom
            aria-role="menuitem"
          >
            <template>
              <b>{{ me.first_name }} {{ me.last_name }}</b>
            </template>
          </b-dropdown-item>
          <hr class="dropdown-divider" />
          <b-dropdown-item has-link aria-role="menuitem" to>
            <router-link :to="{ name: 'UserProfile' }">
              <b-icon icon="user" pack="fa"></b-icon>
              Profil
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="isPermited(['org_admin', 'admin'])"
            has-link
            aria-role="menuitem"
            to
          >
            <router-link :to="{ name: 'OrgProfile' }">
              <b-icon icon="building" pack="fas"></b-icon>
              Organisation
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item
            aria-role="menuitem"
            class="is-flex is-align-items-center"
            @click="logout"
          >
            <b-icon icon="sign-out-alt" pack="fas"></b-icon>
            Abmelden
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import logo from '../assets/GM-Logo-weiß.png';

export default {
  // props: ['initialIsMenuActive'],
  data() {
    return {
      // isMenuActive: this.initialIsMenuActive,
      logo,
    };
  },
  computed: {
    ...mapGetters({
      loggedIn: 'auth/loggedIn',
      me: 'user/me',
      loadingUser: 'user/loading',
      isMenuVisible: 'isMenuVisible',
      isPermited: 'user/isPermited',
    }),
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    },
    togglerArrow() {
      return this.isMenuVisible ? 'angle-double-left' : 'angle-double-right';
    },
  },
  methods: {
    ...mapMutations({
      toggleMenu: 'TOGGLE_MENU_VISIBILITY',
      toggleSearchBar: 'TOGGLE_SEARCH_BAR',
      setSearchBarFocus: 'SET_SEARCH_BAR_FOCUS',
    }),
    onNavSearchClick() {
      const inHome = this.$route.name === 'Home';
      const inSearchPage = this.$route.name === 'SearchResult';

      if (inHome || inSearchPage) {
        this.setSearchBarFocus(true);
      } else {
        this.toggleSearchBar();
      }
    },
    logout() {
      this.$store.dispatch('auth/LOGOUT').then(() => this.$router.push({ name: 'Login' }));
    },
  },
};
</script>

<style>
.stamo-navbar .navbar-brand {
  align-items: center;
}

.gold-nav-item {
  color: #ffffff !important;
}

.gold-nav-item:hover {
  color: #ac8856 !important;
  background-color: white;
}

.menu-label {
  margin-top: 1.2em !important;
  margin-bottom: 0.5em !important;
}

.stamo-navbar .navbar-item {
  padding-top: 0;
  padding-bottom: 0;
}

.stamo-navbar .navbar-brand .navbar-item.logo.is-active {
  background-color: unset;
}

.stamo-navbar .navbar-start .dropdown {
  display: flex;
}

.stamo-navbar .navbar-start .dropdown + .dropdown {
  margin-left: 0;
}

.stamo-navbar .dropdown .dropdown-menu .has-link a.router-link-active {
  background-color: whitesmoke;
  color: #455a64;
}

@media screen and (max-width: 1023px) {
  .stamo-navbar .navbar-menu .navbar-item {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .stamo-navbar .navbar-menu .navbar-start {
    margin-left: 5rem;
  }
}

.user-dropdown.dropdown.dropdown-menu-animation .dropdown-menu {
  z-index: 999 !important;
}
</style>
